module.exports = __webpack_public_path__ + "assets/img/logo-large.e6961253.png";